import { render } from "./MissionAbout.vue?vue&type=template&id=be8e1448&scoped=true"
import script from "./MissionAbout.vue?vue&type=script&lang=js"
export * from "./MissionAbout.vue?vue&type=script&lang=js"

import "./MissionAbout.vue?vue&type=style&index=0&id=be8e1448&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be8e1448"]])

export default __exports__